import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import draftmanJobApi from '../../../APIs/draftman';
import { ReactComponent as DeleteSVG } from '../../../assets/icons/delete.svg';
import { ReactComponent as UpdateSVG } from '../../../assets/icons/refresh.svg';
import ConfirmationModalJob from '../../../components/ConfirmationModal/ConfirmationModal';
import JobInformation from '../../../components/DraftmanBrowsedJobDetails/JobInformation';
import PricingInformation from '../../../components/DraftmanBrowsedJobDetails/PricingInformation';
import DraftmanImageInformation from '../../../components/DraftmanBrowsedJobDetails/PrintingInformation';
import ShippingAddress from '../../../components/PrinterBrowsedJobDetails/ShippingAddress';
import {
  Button,
  Divider,
  Flex,
  Tag,
  Typography,
} from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { humanReadableDateWithTime, requestAPI } from '../../../utils';
import Assignto from './Assignto';
import { ActionsContainer, DraftmanJobDetailsStyled } from './style';

type Props = {};

const ViewDetail = (_props: Props) => {
  const { draftJobId } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const _navigate = useNavigate();
  const singleJob = useSelector(
    (state: RootState) => state.singleDraftmanJobData,
  );
  const getSingleJob = async () => {
    try {
      await requestAPI(draftmanJobApi.getSingleJobOfDraftman(draftJobId || ''));
    } catch (error: any) {
      console.error(error);
      toast.error(error);
    }
  };
  useEffect(() => {
    getSingleJob();
  }, []);

  const acceptJob = async (id: string) => {
    try {
      setIsloading(true);

      await requestAPI(
        draftmanJobApi.acceptRejectDraftJob(id, { status: 'ACCEPTED' }),
      );
      setIsloading(false);
      toast.success('job accepted successfully');
    } catch (error) {
      console.error(error);
      setIsloading(false);
    }
  };
  const rejectJob = async (id: string) => {
    try {
      setIsloading(true);

      await requestAPI(
        draftmanJobApi.acceptRejectDraftJob(id, { status: 'ACCEPTED' }),
      );
      setIsloading(false);
      toast.success('job accepted successfully');
    } catch (error) {
      console.error(error);
      setIsloading(false);
    }
  };

  return (
    <div className="contents">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="title" style={{ marginLeft: '12px' }}>
          Jobs Details{' '}
        </Typography>
        <Tag>{singleJob?.status || ''}</Tag>
      </div>
      <Divider spaceY="20px" />

      <DraftmanJobDetailsStyled>
        {/* <DraftmanInformation email="" imgUrl="" name="" /> */}
        {/* <Divider spaceY="20px" /> */}
        <JobInformation
          jobCreatedAt={humanReadableDateWithTime(singleJob?.createdAt || '')}
          jobTitle={singleJob?.title || ''}
          description={singleJob.notes?.map((draft) => draft) || ['']}
        />
        <Divider spaceY="20px" />
        <PricingInformation
          currency={singleJob?.pricingPlan?.priceDenom || ''}
          description={singleJob?.pricingPlan?.notes || ''}
          planName={singleJob?.pricingPlan?.title || ''}
          price={singleJob?.pricingPlan?.price || ''}
        />
        <Divider spaceY="20px" />
        <ShippingAddress shippingAddress={singleJob?.shippingAddress || ''} />
        <Divider spaceY="20px" />
        <DraftmanImageInformation
          imgUrl={
            singleJob?.drafts?.map((draft) => ({
              id: `${draft?._id || ''}`,
              URL: draft?.url || '',
            })) || []
          }
        />
      </DraftmanJobDetailsStyled>

      <Divider spaceY="20px" />
      {singleJob?.status === 'ACCEPTED' ? (
        <Assignto />
      ) : (
        <>
          <Typography
            variant="normal"
            strong
            fontColor="secondary"
            className="section-title"
          >
            ACTIONS
          </Typography>
          <ActionsContainer>
            <Button
              variant="secondary"
              onClick={() => {
                acceptJob(draftJobId || '');
              }}
            >
              <UpdateSVG />
              Accept
            </Button>
            <Button variant="danger" onClick={() => setShowModal(true)}>
              <DeleteSVG /> Reject
            </Button>
          </ActionsContainer>
        </>
      )}
      {showModal ? (
        <ConfirmationModalJob
          message={'Are you sure you want to reject this job ?'}
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        >
          <Flex justifyContent="space-between">
            <Button
              variant="danger"
              onClick={() => {
                rejectJob(draftJobId || '');
              }}
              isLoading={isLoading}
            >
              Reject
            </Button>
            <Button variant="cancel" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
          </Flex>
        </ConfirmationModalJob>
      ) : (
        ''
      )}
    </div>
  );
};

export default ViewDetail;
